<template>
  <div
    id="app"
  >
    <!-- @click="showSketch=!showSketch" -->
    <!-- <img
      v-if="showSketch"
      src="@/assets/sketch2.png"
      :style="{
        position: 'absolute',
        top: 0,
        opacity: 0.2,
        pointerEvents: 'none',
        width: '90%',
        left: '5%',
        zIndex: 1
      }"
    > -->

    <!-- <router-view /> -->
    <Footer />
  </div>
</template>

<script>

import Footer from '@/components/Footer.vue'
// import Home from './pages/Home.vue'

export default {
  name: 'App',
  components: {

    Footer

  }
  // data () {
  //   return { showSketch: false }
  // }
  // components: { Home }
}
</script>

<style>
html,body {
  margin: 0;
  padding: 0;
  /* background: rgb(248, 248, 248); */
}
#app {
  font-family: -apple-system,Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,SimSun,Segoe UI,Roboto,sans-serif;
  color: #142225;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* color: #2c3e50; */

}

.page {
  /* display: flex;
  flex-direction: column;
  align-items: center; */
  /* background: red; */
}
/* .page.topSpace {
  padding-top: calc(120px + 6vw);
}

@media screen and ( max-width: 720px ) {
  .page.topSpace {
    padding-top: 120px
  }
} */

/* 排版 */
.row{
  display: flex;
  flex-direction: row;
}
.col{
  display: flex;
  flex-direction: column;
}

h1,h2,h3,p{
  margin: 0;
}

.hl,.hlr {
  /* text-shadow: 0 0 1px rgb(59, 59, 59); */
  font-weight: bold;
}
.hl {
  background: linear-gradient(rgba(0, 0, 0, 0) 0px, rgba(0, 0, 0, 0) calc(87.9% - 5px), rgb(255, 201, 180) calc(87.9% - 5px), rgb(255, 226, 245) calc(87.9% + 3px), rgba(0, 0, 0, 0) calc(87.9% + 3px));
}
.hlr {
  background: linear-gradient(rgba(0, 0, 0, 0) 0px, rgba(0, 0, 0, 0) calc(87.9% - 5px), rgb(255, 246, 162) calc(87.9% - 5px), rgb(255, 233, 135) calc(87.9% + 3px), rgba(0, 0, 0, 0) calc(87.9% + 3px));
}
/* .hl::b */
/* h1 { */
  /* font-size: 42px; */
/* } */

/* p { */
  /* font-size: 17px; */
/* } */

/* 移动端 */
/* .onlyMobile { display: hidden ;}
@media screen and ( max-width: 960px ) {
  .onlyMobile { visibility: initial;}
} */

/* pc端 */
/* .onlyPC { visibility: hidden ;}
@media screen and ( min-width: 960px ) {
  .onlyPC { visibility: initial;}
} */

</style>
